import { useContext, useEffect } from 'react';
import { appStore } from 'store/app';
import { CUSTOM_OPSIONS_PARAM_KEY } from 'config-app/config';

const useUrlPram = () => {
  const [appState] = useContext(appStore);

  useEffect(() => {
    // console.log('appState', appState.steps);
    const ids = appState.steps.map((item) => item.id);
    // カスタムオプションをカンマ区切りに変換
    const optionValue = ids.join(',');
    const url = new URL(window.location.href);
    // パラメータにカスタムオプションを追加/上書き
    url.searchParams.set(CUSTOM_OPSIONS_PARAM_KEY, optionValue);
    // 更新した URL で replaceState()
    window.history.replaceState(ids, null, url.toString());
  }, [appState.steps]);
};

export default useUrlPram;
